import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import styles from './HelpIcon.module.css';

type Props = {
  title: string;
}

export default function HelpIcon({ title }: Props) {
    return (
        <Tooltip title={title} arrow>
            <HelpOutlineIcon className={styles.icon} />
        </Tooltip>
    );
}
